"use client";

import React from "react";
import { Check } from "lucide-react";
export default function ProductPresentation() {
  const targetSegments = [{
    title: "Hospitals\n"
  }, {
    title: "Ambulatory Surgery Centers\n"
  }, {
    title: "Outpatient Surgical Facilities\n"
  }, {
    title: "Private Surgical Practices\n\n"
  }, {
    title: "Outpatient Surgical Facilities"
  }];
  return <section id="whoweserve" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-start">
          <div className="w-full lg:w-1/2">
            <div className="w-full">
              <div className="mb-8">
                <h2 className="text-2xl md:text-4xl font-bold text-foreground uppercase tracking-tight font-sans">
                  Who We Serve
                </h2>
                <div className="h-1 w-24 bg-accent-foreground mt-4 rounded-full"></div>
              </div>

              <p className="text-lg text-muted-foreground mb-6 font-sans">
                Atlas Surgical Partners supports surgical and perioperative teams across a range of healthcare environments.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12">
                {targetSegments.map((item, i) => <div key={i} data-index={i} className="flex items-center gap-4 p-5 bg-card border border-border/10 rounded-xl transition-all duration-300 group !border-none border-1 border-[oklab(0.603001-0.0053722-0.013398/0.1)] !shadow-[0px_4px_8px_rgba(20,21,31,0.18),_0px_2px_4px_rgba(20,21,31,0.13)] hover:shadow-md">
                    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/5 flex items-center justify-center group-hover:bg-primary/10 transition-colors">
                      <Check className="w-5 h-5 text-primary" />
                    </div>
                    <span className="text-base font-semibold text-foreground leading-tight">
                      {item.title}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <img src="https://current-narwhal.10web.cloud/wp-content/uploads/2026/04/hm-med-office-01.jpg.bv_.webp" alt="Who we serve illustration" className="w-full h-auto rounded-2xl shadow-xl" />
          </div>
        </div>
      </div>
    </section>;
}